var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMy = function SvgMy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6.5,
    r: 3.5,
    stroke: "#AAA6A6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#AAA6A6",
    strokeWidth: 1.5,
    d: "M9.366 12.75h5.268a5.25 5.25 0 0 1 5.111 4.05l.448 1.915a1.25 1.25 0 0 1-1.216 1.535H5.023c-.805 0-1.4-.75-1.216-1.535l.448-1.914a5.25 5.25 0 0 1 4.884-4.046z"
  })));
};
export default SvgMy;